import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Avatar,
  Divider,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  TextField,
  Container,
  Modal,
  Stack,
  IconButton,
  Tab,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CardMedia,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import {
  Home as HomeIcon,
  MonetizationOn,
  LocalFlorist,
  Healing,
  Book,
  People,
  Delete as DeleteIcon,
  Refresh as RefreshIcon,
  Check as CheckIcon,
  Print as PrintIcon,
  AttachMoney as AttachMoneyIcon,
  CreditCard as CreditCardIcon,
  Search,
} from "@mui/icons-material";
import { Info, Mail, MoneyOff, Settings } from "@mui/icons-material";
import { TabContext, TabPanel, TabList } from "@mui/lab";
import { getApi, postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";
import { set } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import toast from "react-hot-toast";
import { updateCart } from "../../actions";
import moment from "moment";
import { Controller, useForm } from "react-hook-form";
import { Country, State, City } from "country-state-city";

// Styled components
const DemoBanner = styled(Box)(({ theme }) => ({
  background:
    "repeating-linear-gradient(45deg, #926d4f, #926d4f 10px, #a88566 10px, #a88566 20px)",
  color: "#fff",
  textAlign: "center",
  padding: theme.spacing(1),
  fontWeight: 600,
  boxShadow: theme.shadows[2],
}));

const ProductItem = styled(Card)(({ theme }) => ({
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "rgba(146, 109, 79, 0.1)",
    boxShadow: theme.shadows[4],
  },
}));

const ProductItemMedia = styled(Box)(({ theme }) => ({
  height: "80px",
  width: "217px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#FFF8E1",
  marginBottom: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  overflow: "hidden",
}));

const initialOptions = {
  "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
  "buyer-country": "US",
  currency: "USD",
  components: "buttons",
};

const NumpadButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5),
  fontSize: "1.25rem",
  fontWeight: "bold",
  backgroundColor: "#8B4513",
  color: "white",
  "&:hover": {
    backgroundColor: "#704214",
  },
}));

const TemplePoSSystem = () => {
  // State
  const [cart, setCart] = useState([]);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [donorName, setDonorName] = useState("");
  const [donorEmail, setDonorEmail] = useState("");
  const [selectedOption, setSelectedOption] = useState("All Items");
  const [selectedServiceCategory, setSelectedServiceCategory] =
    useState("All Items");
  const [selectedServiceOption, setSelectedServiceOption] =
    useState("All Items");
  const [tabValue, setTabValue] = useState(0);
  const [donationItem, setDonationItem] = useState(null);
  const [serviceData, setServiceData] = useState();
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedDate, setSelectedDate] = useState({});
  const [quantityCounts, setQuantityCounts] = useState({});
  const tabLabels = ["General", "Custom"];
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const dispatch = useDispatch();
  const serviceCartArr = useSelector((state) => state.cartArr);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    watch,
  } = useForm();
  console.log(selectedDate);
  const handleDateChange = (date, service) => {
    setSelectedDate((prevDates) => ({
      ...prevDates,
      [service._id]: date,
    }));
  };

  const captureOrder = async (actions) => {
    try {
      const response = await postApi(
        apiEndPoints.payPalCaptureOrder.replace(":id", paymentMethod)
      );
      if (response?.data.status == "COMPLETED") {
        console.log("Payment successful:", response);
        // navigate("/payment?success=true");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const productData = serviceCartArr?.map((item) => {
    if (item?.type !== 3) {
      return {
        _id: item._id,
        type: item.type,
        type_id: item.type_id,
        name: item.title,
        quantity: item.quantity || 1,
        price: item.amount,
        date: item.selectedDate || new Date(),
        cut_off_hours: item.cut_off_hours,
        cut_off_service_time: item.cut_off_service_time,
        cut_off_type: item.cut_off_type,
        location: item.location,
        booking_config: item.booking_config,
        row_data: {},
        page: item.page,
      };
    } else {
      return {
        _id: item._id,
        type: item.type,
        type_id: item.type_id,
        name: item.title,
        quantity: item.quantity || 1,
        price: item.total,
        date: item.selectedDate || new Date(),
      };
    }
  });

  useEffect(() => {
    const total = serviceCartArr.reduce(
      (sum, item) => sum + Number(item.amount) * (item.quantity || 1),
      0
    );
    setTotalAmount(total);
  }, [serviceCartArr]);
  const tabIcons = [
    <MoneyOff size={20} />,
    <Settings size={20} />,
    <MoneyOff size={20} />,
    <Info size={20} />,
    <Mail size={20} />,
  ];

  // Products data with image URLs

  // Filter products by category

  // Calculate totals

  // Add product to cart
  const addToCart = (product) => {
    const existingItemIndex = cart.findIndex(
      (item) => item.name === product.name
    );

    if (existingItemIndex !== -1) {
      // Item exists, update quantity
      const updatedCart = [...cart];
      updatedCart[existingItemIndex].quantity += 1;
      setCart(updatedCart);
    } else {
      // Add new item
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  };

  // Remove selected item from cart
  const removeItem = () => {
    if (selectedItemIndex !== null) {
      const updatedCart = cart.filter(
        (_, index) => index !== selectedItemIndex
      );
      setCart(updatedCart);
      setSelectedItemIndex(null);
    }
  };

  // Clear cart
  const clearCart = () => {
    setCart([]);
    setSelectedItemIndex(null);
  };

  // Add custom donation
  const addCustomDonation = () => {
    const amount = prompt("Enter custom donation amount:", "10.00");
    if (amount && !isNaN(parseFloat(amount))) {
      setCart([
        ...cart,
        {
          name: "Custom Donation",
          price: parseFloat(amount),
          quantity: 1,
        },
      ]);
    }
  };

  // Add note to item
  const addNote = () => {
    if (selectedItemIndex !== null) {
      const note = prompt("Add a note to this item:", "");
      if (note) {
        const updatedCart = [...cart];
        updatedCart[selectedItemIndex].note = note;
        setCart(updatedCart);
      }
    } else {
      alert("Please select an item first");
    }
  };

  // Handle checkout
  const handleCheckout = () => {
    if (cart.length > 0) {
      setOpenModal(true);
    } else {
      alert("Please add items to your cart first");
    }
  };
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Start new sale after checkout
  const startNewSale = () => {
    setOpenModal(false);
    clearCart();
    setDonorName("");
    setDonorEmail("");
    setPaymentMethod("Cash");
  };

  const getServicesData = async () => {
    try {
      let slug = "daily";
      switch (selectedServiceOption) {
        case "Daily Services":
          slug = "daily";
          break;
        case "Weekly Services":
          slug = "weekly";
          break;
        case "Monthly Services":
          slug = "monthly";
          break;
        case "Anual Services":
          slug = "annual";
          break;
        case "Special Services":
          slug = "special";
          break;
        case "Personal Services":
          slug = "personal";
          break;
        case "Vahana Sevas":
          slug = "vahana_sevas";
          break;
        case "Reccuring Services":
          slug = "recurringServices";
          break;
      }

      const response = await postApi(
        apiEndPoints.getAllServicesAtTempleByServicesSlug,
        { slug }
      );
      setServiceData(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  const shouldDisableDate = (date, i) => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    new Date(date).setHours(0, 0, 0, 0);
    return date < currentDate;
  };
  useEffect(() => {
    getServicesData();
  }, [selectedServiceOption]);

  // Select category
  const handleCategoryChange = (category) => {
    setSelectedOption(category);
  };

  // Format currency
  const formatCurrency = (amount) => {
    if (amount) return `$${amount.toFixed(2)}`;
  };

  const getAllDonations = async () => {
    const response = await getApi(apiEndPoints.getAllDonations);
    console.log(response);
    if (response && response.status === 200) {
      console.log("Donation items:", response);
      setDonationItem(response?.data?.data);
    }
  };

  const getCountryData = () => {
    const countries = Country.getAllCountries();
    setCountry(countries);
  };

  const handleCountryChange = (countryCode) => {
    const states = State.getStatesOfCountry(countryCode);
    setState(states);
    setCity([]);
  };

  const handleStateChange = (stateCode, countryCode) => {
    const cities = City.getCitiesOfState(countryCode, stateCode);
    console.log("hi", cities);
    setCity(cities);
  };

  useEffect(() => {
    getAllDonations();
    getCountryData();
  }, []);

  const handleOrderPuja = async (item, serviceType, page) => {
    if (
      item.booking_config === "Online booking not available call temple to book"
    ) {
      const response = await postApi(apiEndPoints.getBookingConfigByTitle, {
        title: item.booking_config,
      });
      toast.error(response.data.data.data.message);
      return;
    }
    if (item.amount !== 0) {
      if (!selectedDate[item._id]) {
        toast.error("Please select a date.");
        return;
      }

      const existingCartItem = serviceCartArr.find(
        (cartItem) => cartItem._id === item._id
      );
      if (existingCartItem) {
        const updatedItem = {
          ...existingCartItem,
          type_id: 1,
          page: page,
          quantity: quantityCounts[item._id] || 1,
          selectedDate: selectedDate[item._id],
        };
        dispatch(updateCart(updatedItem));
        toast.success("Your puja/donation has been successfully updated.");
      } else {
        const newItem = {
          ...item,
          type_id: 1,
          page: page,
          quantity: quantityCounts[item._id] || 1,
          selectedDate: selectedDate[item._id],
        };
        dispatch(updateCart(newItem));
        toast.success(
          "Your puja/donation has been successfully added to the puja basket."
        );
      }
    } else {
      toast.error(
        "You can't book this puja. For more information, please contact the temple."
      );
    }
  };
  return (
    <Box
      sx={{
        fontFamily: "'Roboto', sans-serif",
        backgroundColor: "#f8f5f0",
        minHeight: "100vh",
        padding: 1,
      }}
    >
      {/* Demo Banner */}

      <Grid container spacing={3} sx={{ height: "100%" }}>
        {/* Left Side - Product List and Receipt */}

        <Grid item xs={12} lg={8} sx={{ height: "100%" }}>
          <Card sx={{ height: "1000px" }}>
            {/* Header */}
            <Grid sx={{ height: "8%" }}>
              <Grid
                container
                sx={{
                  backgroundColor: "#8B4513",
                  color: "#fff",
                }}
                p={1.5}
              >
                <Grid
                  item
                  sx={{ display: "flex", alignItems: "center" }}
                  sm={9}
                >
                  <HomeIcon sx={{ fontSize: 30, mr: 1 }} />
                  <Typography
                    variant="h5"
                    component="h1"
                    sx={{ fontWeight: "bold" }}
                  >
                    Temple Offerings & Donations
                  </Typography>
                </Grid>
                <Grid
                  item
                  sx={{ display: "flex", alignItems: "center" }}
                  sm={3}
                >
                  <Typography variant="body1" sx={{ mr: 1 }}>
                    Cashier : Dharma
                  </Typography>
                  <Avatar
                    sx={{
                      bgcolor: "#FFF8E1",
                      color: "#8B4513",
                      fontWeight: "bold",
                    }}
                  >
                    D
                  </Avatar>
                </Grid>
              </Grid>
            </Grid>

            {/* Receipt Area */}
            <Grid sx={{ height: "30%", mb: 1 }}>
              <TableContainer
                component={Paper}
                sx={{
                  height: "100%", // Fill the Grid height
                  overflow: "auto", // Enable scroll
                  boxShadow: "none",
                }}
              >
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow sx={{ borderBottom: "1px dashed #FFE082" }}>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          backgroundColor: "#FFF8E1",
                          zIndex: 1,
                        }}
                      >
                        Item
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          backgroundColor: "#FFF8E1",
                          zIndex: 1,
                        }}
                      >
                        Date
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: 600,
                          backgroundColor: "#FFF8E1",
                          zIndex: 1,
                        }}
                      >
                        Qty
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          fontWeight: 600,
                          backgroundColor: "#FFF8E1",
                          zIndex: 1,
                        }}
                      >
                        Amount
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {serviceCartArr.map((item, index) => (
                      <TableRow
                        key={`${item.title}-${index}`}
                        hover
                        selected={selectedItemIndex === index}
                        onClick={() => setSelectedItemIndex(index)}
                        sx={{
                          cursor: "pointer",
                          backgroundColor:
                            selectedItemIndex === index
                              ? "#FFF8E1"
                              : "transparent",
                          borderBottom: "1px dotted #FFE082",
                          "&:hover": {
                            backgroundColor: "#FFF8E1",
                          },
                        }}
                      >
                        <TableCell>{item.title}</TableCell>
                        <TableCell>
                          {moment
                            .utc(new Date(item?.selectedDate || new Date()))
                            .format("dddd, MMMM Do YYYY")}
                        </TableCell>
                        <TableCell align="center">{item.quantity}</TableCell>
                        <TableCell align="right">
                          ${item.amount * item.quantity}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            {/* Product Categories */}

            {/* Products Grid */}
            <Grid sx={{ height: "72%", px: 2 }}>
              <ButtonGroup
                variant="outlined"
                sx={{
                  mb: 2,
                  display: "flex",
                  flexWrap: "wrap",
                  "& > *": {
                    flexGrow: 1,
                    maxWidth: { xs: "100%", sm: "auto" },
                  },
                }}
              >
                {["Donations", "Offerings", "Merchandise", "Services"].map(
                  (category) => (
                    <Button
                      key={category}
                      onClick={() => {
                        handleCategoryChange(category);
                        setSelectedServiceCategory("");
                        setSelectedServiceOption("");
                      }}
                      sx={{
                        backgroundColor:
                          selectedOption === category ? "#8B4513" : "#FFF8E1",
                        color:
                          selectedOption === category
                            ? "white !important"
                            : "#8B4513",
                        "&:hover": {
                          backgroundColor:
                            selectedOption === category ? "#704214" : "#FFE082",
                        },
                      }}
                    >
                      {category}
                    </Button>
                  )
                )}
              </ButtonGroup>
              {selectedOption === "Services" && (
                <ButtonGroup
                  variant="outlined"
                  sx={{
                    mb: 2,
                    display: "flex",
                    flexWrap: "wrap",
                    "& > *": {
                      flexGrow: 1,
                      maxWidth: { xs: "100%", sm: "auto" },
                    },
                  }}
                >
                  {["Service At Temple", "Service Outside Temple"].map(
                    (category) => (
                      <Button
                        key={category}
                        onClick={() => {
                          setSelectedServiceCategory(category);
                        }}
                        sx={{
                          backgroundColor:
                            selectedServiceCategory === category
                              ? "#8B4513"
                              : "#FFF8E1",
                          color:
                            selectedServiceCategory === category
                              ? "white !important"
                              : "#8B4513",
                          "&:hover": {
                            backgroundColor:
                              selectedServiceCategory === category
                                ? "#704214"
                                : "#FFE082",
                          },
                        }}
                      >
                        {category}
                      </Button>
                    )
                  )}
                </ButtonGroup>
              )}
              {selectedOption === "Services" &&
                selectedServiceCategory == "Service At Temple" && (
                  <ButtonGroup
                    variant="outlined"
                    sx={{
                      mb: 2,
                      display: "flex",
                      flexWrap: "wrap",
                      "& > *": {
                        flexGrow: 1,
                        maxWidth: { xs: "100%", sm: "auto" },
                      },
                    }}
                  >
                    {[
                      "Daily Services",
                      "Weekly Services",
                      "Monthly Services",
                      "Anual Services",
                      "Special Services",
                      "Personal Services",
                      "Vahana Sevas",
                      "Reccuring Services",
                    ].map((category) => (
                      <Button
                        key={category}
                        onClick={() => {
                          setSelectedServiceOption(category);
                        }}
                        sx={{
                          backgroundColor:
                            selectedServiceOption === category
                              ? "#8B4513"
                              : "#FFF8E1",
                          color:
                            selectedServiceOption === category
                              ? "white !important"
                              : "#8B4513",
                          "&:hover": {
                            backgroundColor:
                              selectedServiceOption === category
                                ? "#704214"
                                : "#FFE082",
                          },
                        }}
                      >
                        {category}
                      </Button>
                    ))}
                  </ButtonGroup>
                )}
              <Grid
                container
                spacing={2}
                sx={{ height: "90%", overflow: "auto" }}
              >
                {serviceData?.map((category) => (
                  <Grid item xs={6} sm={3} md={3}>
                    <Card
                      onClick={() => addToCart(category)}
                      sx={{
                        height: "300px",
                      }}
                    >
                      <CardMedia
                        component="img"
                        sx={{
                          width: "100%",
                          height: "160px",
                          objectFit: "fill",
                        }}
                        image={category?.image}
                      />
                      <Grid
                        container
                        sx={{ minHeight: "40px", maxHeight: "40px" }}
                      >
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {category?.title}
                        </Typography>
                      </Grid>
                      <Grid container sx={{ height: "50px" }}>
                        <Grid item xs={8} sm={9} md={9} sx={{ height: "100%" }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            {/* Date Picker */}
                            <DatePicker
                              label="Select a date"
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  size: "medium",
                                },
                              }}
                              value={selectedDate[category._id]}
                              onChange={(date) =>
                                handleDateChange(date, category)
                              }
                              shouldDisableDate={(date) =>
                                shouldDisableDate(date, category)
                              }
                            />
                          </LocalizationProvider>
                        </Grid>
                        {/* Quantity Select */}
                        <Grid item xs={3} sm={3} md={3} sx={{ height: "100%" }}>
                          <FormControl variant="outlined" sx={{ minWidth: 62 }}>
                            <InputLabel id="qty-label">Qty</InputLabel>
                            <Select
                              sx={{
                                maxHeight: "45px",
                                "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select":
                                  { background: "none !important" },
                              }}
                              labelId="qty-label"
                              id="qty"
                              value={quantityCounts[category?._id] || 1}
                              onChange={(e) =>
                                setQuantityCounts((prevCounts) => ({
                                  ...prevCounts,
                                  [category?._id]: e.target.value,
                                }))
                              }
                              label="Qty"
                            >
                              {[1, 2, 3, 4, 5].map((val) => (
                                <MenuItem key={val} value={val}>
                                  {val}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid container sx={{ height: "50px" }}>
                        <Grid
                          item
                          xs={9}
                          sm={9}
                          md={9}
                          onClick={() => {
                            handleOrderPuja(category, "atTemple", "temple");
                          }}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            backgroundColor: "#901500",
                            color: "white !important",
                            height: "100%",
                          }}
                        >
                          Order Puja
                        </Grid>
                        {/* Quantity Select */}
                        <Grid
                          item
                          xs={3}
                          sm={3}
                          md={3}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#9d5f03",
                            color: "white !important",
                            height: "100%",
                          }}
                        >
                          $ {category?.amount}
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Card>
        </Grid>

        {/* Right Side - Checkout Panel */}
        <Grid item xs={12} lg={4}>
          <Paper elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
            {/* Order Summary */}
            <Box sx={{ bgcolor: "#FFF8E1", p: 2 }}>
              <Typography
                variant="h6"
                sx={{ mb: 1, fontWeight: "bold", color: "#8B4513" }}
              >
                Puja Basket
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography>Subtotal</Typography>
                <Typography>${totalAmount}</Typography>
              </Box>

              <Divider sx={{ borderColor: "#FFE082", my: 1 }} />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                }}
              >
                <Typography sx={{ fontWeight: "bold" }}>Total</Typography>
                <Typography sx={{ fontWeight: "bold" }}>
                  ${totalAmount}
                </Typography>
              </Box>
            </Box>

            {/* Numpad */}
            <Box sx={{ p: 2 }}>
              <Grid container spacing={1} sx={{ mb: 2 }}>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      bgcolor: "#FFF8E1",
                      color: "#8B4513",
                      "&:hover": { bgcolor: "#FFE082" },
                    }}
                  >
                    Qty
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      bgcolor: "#FFF8E1",
                      color: "#8B4513",
                      "&:hover": { bgcolor: "#FFE082" },
                    }}
                    onClick={addCustomDonation}
                  >
                    Custom
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      bgcolor: "#FFF8E1",
                      color: "#8B4513",
                      "&:hover": { bgcolor: "#FFE082" },
                    }}
                    onClick={addNote}
                  >
                    Note
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<DeleteIcon />}
                    sx={{
                      bgcolor: "#FFEBEE",
                      color: "#d32f2f",
                      "&:hover": { bgcolor: "#FFCDD2" },
                    }}
                    onClick={removeItem}
                  >
                    Remove Item
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<RefreshIcon />}
                    sx={{
                      bgcolor: "#FFF8E1",
                      color: "#8B4513",
                      "&:hover": { bgcolor: "#FFE082" },
                    }}
                    onClick={clearCart}
                  >
                    Clear All
                  </Button>
                </Grid>
              </Grid>
              <ButtonGroup
                variant="outlined"
                sx={{
                  mb: 2,
                  display: "flex",
                  flexWrap: "wrap",
                  "& > *": {
                    flexGrow: 1,
                    maxWidth: { xs: "100%", sm: "auto" },
                  },
                }}
              >
                {["Guest Checkout ", "Devotee Checkout"].map((category) => (
                  <Button
                    key={category}
                    onClick={() => {
                      handleCategoryChange(category);
                      setSelectedServiceCategory("");
                      setSelectedServiceOption("");
                    }}
                    sx={{
                      backgroundColor:
                        selectedOption === category ? "#8B4513" : "#FFF8E1",
                      color:
                        selectedOption === category
                          ? "white !important"
                          : "#8B4513",
                      "&:hover": {
                        backgroundColor:
                          selectedOption === category ? "#704214" : "#FFE082",
                      },
                    }}
                  >
                    {category}
                  </Button>
                ))}
              </ButtonGroup>
              <TextField
                fullWidth
                placeholder="Search devotee"
                {...register("search")}
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onClick={async () => {
                          const res = await postApi(
                            apiEndPoints.getDevoteeBySearch,
                            {
                              query: watch("search"),
                            }
                          );
                          if (res?.data.data == null) {
                            reset({
                              firstName: "",
                              lastName: "",
                              email: "",
                              zipCode: "",
                              address: "",
                              city: "",
                            });
                            toast.error("Devotee dose not exist");
                          } else {
                            handleCountryChange(
                              res?.data?.data?.address?.country
                            );
                            handleStateChange(
                              res?.data?.data?.address?.state,
                              res?.data?.data?.address?.country
                            );
                            reset({
                              firstName: res?.data?.data?.first_name,
                              lastName: res?.data?.data?.last_name,
                              email: res?.data?.data?.email,
                              zipCode: res?.data?.data?.address?.zipcode,
                              address: res?.data?.data?.address?.address,
                              city: res?.data?.data?.address?.city,
                              country: res?.data?.data?.address?.country,
                              state: res?.data?.data?.address?.state,
                            });
                          }
                        }}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    placeholder="First Name"
                    size="small"
                    {...register("firstName")}
                    InputProps={{ sx: { bgcolor: "white" } }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    placeholder="Last Name"
                    size="small"
                    {...register("lastName")}
                    InputProps={{ sx: { bgcolor: "white" } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    placeholder="Email"
                    size="small"
                    {...register("email")}
                    InputProps={{ sx: { bgcolor: "white" } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    placeholder="Address"
                    size="small"
                    {...register("address")}
                    InputProps={{ sx: { bgcolor: "white" } }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="country"
                    render={({ field, fieldState }) => {
                      return (
                        <FormControl
                          key={field.value}
                          fullWidth
                          error={fieldState?.error?.message}
                          className="dropdown-margin-top"
                        >
                          <InputLabel id="demo-simple-select-label">
                            Select Country *
                          </InputLabel>
                          <Select
                            {...field}
                            labelId="demo-simple-select-label"
                            label="Select Country *"
                            onChange={async (e) => {
                              field.onChange(e.target.value);
                              handleCountryChange(e.target.value);
                            }}
                          >
                            {country?.map((item) => (
                              <MenuItem key={item.isoCode} value={item.isoCode}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText error>
                            {fieldState?.error?.message}
                          </FormHelperText>
                        </FormControl>
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="state"
                    render={({ field, fieldState }) => {
                      return (
                        <FormControl
                          key={field.value}
                          fullWidth
                          error={fieldState?.error?.message}
                          className="dropdown-margin-top"
                        >
                          <InputLabel id="demo-simple-select-label">
                            Select State *
                          </InputLabel>
                          <Select
                            {...field}
                            labelId="demo-simple-select-label"
                            label="Select State *"
                            onChange={async (e) => {
                              field.onChange(e.target.value);
                              handleStateChange(
                                e.target.value,
                                watch("country")
                              );
                            }}
                            defaultValue={field.value}
                          >
                            {state?.map((item) => (
                              <MenuItem key={item.isoCode} value={item.isoCode}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText error>
                            {fieldState?.error?.message}
                          </FormHelperText>
                        </FormControl>
                      );
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Controller
                    control={control}
                    name="city"
                    render={({ field, fieldState }) => {
                      return (
                        <FormControl
                          key={field.value}
                          fullWidth
                          error={fieldState?.error?.message}
                          className="dropdown-margin-top"
                        >
                          <InputLabel id="demo-simple-select-label">
                            Select City *
                          </InputLabel>
                          <Select
                            {...field}
                            labelId="demo-simple-select-label"
                            label="Select State *"
                            defaultValue={field.value}
                          >
                            {city.map((city) => (
                              <MenuItem key={city.name} value={city.name}>
                                {city.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText error>
                            {fieldState?.error?.message}
                          </FormHelperText>
                        </FormControl>
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    placeholder="Zip Code"
                    size="small"
                    {...register("zipCode")}
                    InputProps={{ sx: { bgcolor: "white" } }}
                  />
                </Grid>
              </Grid>
              {/* Action Buttons */}

              {/* Donor Information */}

              {/* Payment Method */}
              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mb: 1, color: "#8B4513" }}
                >
                  Payment Method
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="contained"
                      startIcon={<AttachMoneyIcon />}
                      sx={{
                        bgcolor:
                          paymentMethod === "Cash" ? "#4caf50" : "#E8F5E9",
                        color: paymentMethod === "Cash" ? "white" : "#2e7d32",
                        "&:hover": {
                          bgcolor:
                            paymentMethod === "Cash" ? "#388e3c" : "#C8E6C9",
                        },
                        border:
                          paymentMethod === "Cash"
                            ? "2px solid #2e7d32"
                            : "none",
                        py: 1,
                      }}
                      onClick={() => setPaymentMethod("Cash")}
                    >
                      Cash
                    </Button>
                  </Grid>

                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="contained"
                      startIcon={<CreditCardIcon />}
                      sx={{
                        bgcolor:
                          paymentMethod === "Card" ? "#2196f3" : "#E3F2FD",
                        color: paymentMethod === "Card" ? "white" : "#1565c0",
                        "&:hover": {
                          bgcolor:
                            paymentMethod === "Card" ? "#1976d2" : "#BBDEFB",
                        },
                        border:
                          paymentMethod === "Card"
                            ? "2px solid #1565c0"
                            : "none",
                        py: 1,
                      }}
                      onClick={async () => {
                        const payload = {
                          lineItems: productData,
                          totalAmount,
                          payoutDetails: {
                            email: "vikasmohansingh19@gmail.com",
                            first_name: "Vikas",
                            last_name: "Chouhan",
                            country: "611ce96de2cd656171314e2b",
                            address: "1125, Scheme No.51",
                            city: "Indore",
                            contact_number: "919098696178",
                            zipCode: "412001",
                            company_name: "",
                            use_for_billing: true,
                            state: "611ceb61e2cd656171314eb8",
                            paymentGateway: 1,
                          },
                          userId: "6785f494da1c396db3c64ce0",
                        };
                        const response = await postApi(
                          apiEndPoints.makePayment,
                          payload
                        );
                        window.location.href = response?.data?.session?.url;
                        // setPaymentMethod(
                        //   response?.data?.paymentData?.payment_session_id
                        // );
                      }}
                    >
                      Card
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      startIcon={<CreditCardIcon />}
                      sx={{
                        bgcolor:
                          paymentMethod === "Card" ? "#2196f3" : "#E3F2FD",
                        color: paymentMethod === "Card" ? "white" : "#1565c0",
                        "&:hover": {
                          bgcolor:
                            paymentMethod === "Card" ? "#1976d2" : "#BBDEFB",
                        },
                        border:
                          paymentMethod === "Card"
                            ? "2px solid #1565c0"
                            : "none",
                        py: 1,
                      }}
                      onClick={async () => {
                        const payload = {
                          lineItems: productData,
                          totalAmount,
                          payoutDetails: {
                            email: "vikasmohansingh19@gmail.com",
                            first_name: "Vikas",
                            last_name: "Chouhan",
                            country: "611ce96de2cd656171314e2b",
                            address: "1125, Scheme No.51",
                            city: "Indore",
                            contact_number: "919098696178",
                            zipCode: "412001",
                            company_name: "",
                            use_for_billing: true,
                            state: "611ceb61e2cd656171314eb8",
                            paymentGateway: 1,
                          },
                          userId: "6785f494da1c396db3c64ce0",
                        };
                        const response = await postApi(
                          apiEndPoints.makePayment,
                          payload
                        );
                        window.location.href = response?.data?.session?.url;
                        // setPaymentMethod(
                        //   response?.data?.paymentData?.payment_session_id
                        // );
                      }}
                    >
                      Tap and pay
                    </Button>
                  </Grid>
                  {/* {setPaymentMethod != "" && (
                    <Grid item xs={12}>
                      <PayPalScriptProvider options={initialOptions}>
                        <PayPalButtons
                          style={{
                            shape: "rect",
                            layout: "vertical",
                            color: "gold",
                            label: "paypal",
                          }}
                          createOrder={() => {
                            return paymentMethod;
                          }}
                          onApprove={captureOrder}
                        />
                      </PayPalScriptProvider>
                    </Grid>
                  )} */}
                </Grid>
              </Box>

              {/* Checkout Button */}
              <Button
                fullWidth
                variant="contained"
                size="large"
                sx={{
                  bgcolor: "#8B4513",
                  color: "white",
                  py: 1.5,
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                  "&:hover": { bgcolor: "#704214" },
                }}
                onClick={handleCheckout}
              >
                Complete Offering
              </Button>
            </Box>
          </Paper>
        </Grid>
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="checkout-modal-title"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 400 },
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
            }}
          >
            <Box sx={{ textAlign: "center" }}>
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  bgcolor: "#FFF8E1",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <CheckIcon sx={{ fontSize: 40, color: "#8B4513" }} />
              </Box>

              <Typography
                id="checkout-modal-title"
                variant="h5"
                component="h2"
                sx={{ mb: 1, fontWeight: "bold", color: "#8B4513" }}
              >
                Payment Successful
              </Typography>

              <Typography
                variant="body1"
                sx={{ color: "text.secondary", mb: 2 }}
              >
                Thank you for your generous contribution.
              </Typography>

              <Paper sx={{ bgcolor: "#FFF8E1", p: 2, mb: 2, borderRadius: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 0.5,
                  }}
                >
                  <Typography>Total Amount:</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    ${totalAmount}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 0.5,
                  }}
                >
                  <Typography>Payment Method:</Typography>
                  <Typography sx={{ fontWeight: "medium" }}>
                    {paymentMethod}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography>Reference ID:</Typography>
                  <Typography sx={{ fontWeight: "medium" }}>
                    TMP-2023-0108
                  </Typography>
                </Box>
              </Paper>

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<PrintIcon />}
                    sx={{
                      bgcolor: "#8B4513",
                      "&:hover": { bgcolor: "#704214" },
                    }}
                    onClick={() =>
                      alert(
                        "Receipt printing simulation. In a real system, this would send data to a receipt printer."
                      )
                    }
                  >
                    Print Receipt
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button fullWidth variant="outlined" onClick={startNewSale}>
                    New Offering
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Modal>
      </Grid>

      {/* Success Modal */}
    </Box>
  );
};

export default TemplePoSSystem;
